
import React, { useEffect, useState } from 'react';
import './SignOutPage.css';

interface SignOutPageProps {
  onComplete: () => void;
}

const SignOutPage: React.FC<SignOutPageProps> = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('Signing out...');

  useEffect(() => {
    // Animate progress
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 20;
      });
    }, 200);

    // Update status messages
    const timeouts = [
      setTimeout(() => setStatus('Clearing session...'), 400),
      setTimeout(() => setStatus('Logging out...'), 800),
      setTimeout(() => setStatus('See you soon!'), 1200),
    ];

    // Complete sign out after animation
    const completeTimeout = setTimeout(() => {
      onComplete();
    }, 1500);

    return () => {
      clearInterval(interval);
      timeouts.forEach(clearTimeout);
      clearTimeout(completeTimeout);
    };
  }, [onComplete]);

  return (
    <div className="signout-page">
      <div className="signout-container">
        <div className="signout-logo">
          <img
            src="https://jalenward.com/images/blackwhitetextjalen.png"
            alt="OnlyJalen"
          />
        </div>

        <div className="signout-content">
          <div className="signout-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
              <polyline points="16,17 21,12 16,7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </div>

          <h1>{status}</h1>

          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>

          <p className="signout-message">
            Thanks for visiting! Come back soon for exclusive content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignOutPage;
